import type { Dispatch, SetStateAction } from "react";
import { useEffect, useState } from "react";
import { useDebounce } from "./function";

export function useControlledValueState<T = any>(
  propValue: T,
  defaultValue: T,
  onChange?: (value: T) => void,
  stringify: (value: T) => string | undefined = JSON.stringify,
  debounce = false,
): [T, Dispatch<SetStateAction<T>>] {
  const [value, setValue] = useState<T>(propValue || defaultValue);
  const callOnChange = useDebounce(onChange, 300);
  useEffect(() => {
    if (onChange && stringify(value) !== stringify(propValue))
      if (debounce) {
        callOnChange(value);
      } else onChange(value);
  }, [value]);
  useEffect(() => {
    if (propValue && stringify(value) !== stringify(propValue))
      setValue(propValue);
  }, [propValue]);

  return [value, setValue];
}
